var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.33577 0.198117C7.3687 0.165607 7.40324 0.138082 7.44111 0.113726C7.45752 0.1024 7.47565 0.0958298 7.49206 0.086088C7.51341 0.0747613 7.53486 0.061735 7.55954 0.0519932C7.5826 0.0422515 7.60555 0.0373811 7.62862 0.0309247C7.64836 0.0244674 7.6681 0.0178985 7.68783 0.0130271C7.73224 0.00487127 7.77665 8.6615e-07 7.82278 8.74217e-07C7.86719 8.81981e-07 7.91321 0.0048713 7.95773 0.0130271C7.97908 0.0163125 7.99721 0.0243549 8.01695 0.0309248C8.04001 0.0373811 8.06296 0.0422515 8.08603 0.0519933C8.10909 0.0617351 8.13044 0.0747604 8.1535 0.0860882C8.16991 0.0958299 8.18804 0.102286 8.20445 0.113727C8.24232 0.138081 8.27847 0.167307 8.3098 0.198117L12.6217 4.45442C12.8899 4.71914 12.8899 5.14776 12.6217 5.41248C12.3535 5.6772 11.9193 5.6772 11.6511 5.41248L8.50724 2.31087L8.50724 9.32284C8.50724 9.69631 8.19957 10 7.82123 10C7.44289 10 7.13522 9.69631 7.13522 9.32284L7.13523 2.31087L3.99456 5.41248C3.72638 5.6772 3.29216 5.6772 3.02398 5.41248C2.7558 5.14776 2.7558 4.71914 3.02398 4.45442L7.33577 0.198117Z",
    fill: "#0089B5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1613 14H1.66143C1.29665 14 1.00001 13.6776 1.00001 13.281V8.71895C1.00001 8.32244 1.29665 8 1.66143 8C2.02621 8 2.32285 8.32244 2.32285 8.71895V12.5619H12.5V8.71895C12.5 8.32244 12.7966 8 13.1614 8C13.5262 8 13.8228 8.32244 13.8228 8.71895V13.281C13.8228 13.6776 13.5261 14 13.1613 14Z",
    fill: "#0089B5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoUpload);
export default __webpack_public_path__ + "static/media/ico_upload.d27d968bee19f738b3a6816608437593.svg";
export { ForwardRef as ReactComponent };